import { render, staticRenderFns } from "./TermsAndConditionsAll.vue?vue&type=template&id=503127ec"
import script from "./TermsAndConditionsAll.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports